import { render, staticRenderFns } from "./DirectoryContactForm.vue?vue&type=template&id=07e1f5d3&scoped=true&"
import script from "./DirectoryContactForm.vue?vue&type=script&lang=js&"
export * from "./DirectoryContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e1f5d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CASADEDIOS\\git\\global_business\\gpb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07e1f5d3')) {
      api.createRecord('07e1f5d3', component.options)
    } else {
      api.reload('07e1f5d3', component.options)
    }
    module.hot.accept("./DirectoryContactForm.vue?vue&type=template&id=07e1f5d3&scoped=true&", function () {
      api.rerender('07e1f5d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/frontend/js/components/DirectoryContactForm.vue"
export default component.exports